import { Input, Form } from 'antd';
import { CityAsyncSelect } from '@/components/pos/CityAsyncSelect';
import { CareStaffAsyncSelect } from '@/components/pos/CareStaffAsyncSelect';
import { FloatingField } from './FloatingField';
import { customerPhoneRules, requiredRule } from './customerFormSchema';
import { careStaffFieldCopy, careStaffRules } from '../../utils/careStaffField';
import { UserType } from '../../types';

interface Props {
  form: import('antd').FormInstance;
  storeId?: string;
  cccdMasked?: boolean;
  onRevealCccd?: () => void;
}

export function CustomerCoreFields({ form, storeId }: Props) {
  // TCR-2429 — dialog này dùng chung cho đơn B2C và B2B: đơn B2B thì ô `care_staff_id` là
  // NVKD ghi nhận doanh số, danh sách cũng khác. Đọc `user_type` ngay tại đây thay vì bắt
  // `CustomerSidebar` truyền xuống — cùng một nguồn với `isB2B` của POS, không thêm prop.
  const userType = (Form.useWatch('user_type', form) as UserType | undefined) ?? UserType.PERSONAL;
  const isB2B = userType === UserType.ORGANIZATION;
  const careStaffCopy = careStaffFieldCopy(isB2B);

  return (
    <>
      <FloatingField
        label="Số điện thoại"
        name="customer_phone"
        rules={customerPhoneRules}
        required
      >
        <Input maxLength={11} />
      </FloatingField>

      <FloatingField
        label={careStaffCopy.label}
        name="care_staff_id"
        rules={careStaffRules(isB2B)}
        required
      >
        <CareStaffAsyncSelect
          placeholder={careStaffCopy.placeholder}
          onChange={(v) => form.setFieldValue('care_staff_id', v)}
          storeId={storeId}
          salesChannel={isB2B ? 'b2b' : undefined}
          initialLabel={form.getFieldValue('_careStaffName')}
        />
      </FloatingField>

      <FloatingField
        label="Thành phố"
        name="customer_city_id"
        rules={[requiredRule('tỉnh/thành phố')]}
        required
      >
        <CityAsyncSelect
          placeholder="Chọn thành phố"
          onChange={(v) => {
            form.setFieldValue('customer_city_id', v);
            form.setFieldsValue({ customer_ward_id: undefined });
          }}
          onChangeWithLabel={(_, name) => form.setFieldValue('_cityName', name)}
        />
      </FloatingField>
    </>
  );
}
